import React, { Component }  from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { compareObjectsInclusive,KEY_CODES } from '../../../common/utils.jsx';
import _ from '../../i18n.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import FormComponent from './../FormComponent.jsx';
import FormComponentItem from './../FormComponentItem.jsx';

import style from './radio.buttons.less';

const { ENTER, SPACE, ARROW_LEFT, ARROW_RIGHT } = KEY_CODES;
const TYPES = PropTypes;

export class Button extends FormComponentItem {
    constructor() {
        super();
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'value', 'checked', 'disabled', 'name', 'id', 'num', 'title' ]);
    }
    onKeyPressHandler(event) {
        const { keyCode } = event;
        if (ENTER === keyCode || SPACE === keyCode) {
            event.preventDefault();
            this.onChangeHandler();
        }
    }
    render() {
        const { title, value, name, id, num, checked, disabled } = this.props;
        const btnId = `${id}-${num}`;
        const btnClass = classNames(style.btn, { [style.active]: checked }, { [style.disabled]: disabled });
        const tabIndex = disabled ? -1 : 0;
        return (
            <label htmlFor={btnId} className={btnClass} tabIndex={tabIndex} onKeyDown={this.onKeyPressHandler} data-index={num}>
                <input type="radio" name={name} id={btnId} onChange={this.onChangeHandler} value={value} checked={checked} className={style.hidden}/>
                <span>{title}</span>
            </label>
        );
    }
}
Button.propTypes = {
    id: TYPES.string.isRequired,
    num: TYPES.number.isRequired,
    name: TYPES.string.isRequired,
    checked: TYPES.bool.isRequired,
    title: TYPES.string.isRequired,
    value: TYPES.any.isRequired,
    onChangeCallback: TYPES.func.isRequired
};
Button.defaultProps = { checked: false };

const UNKNOWN = 'UNKNOWN';
export default class RadioButtons extends FormComponent {
    constructor() {
        super();
        this.arrowKeyHandler = this.arrowKeyHandler.bind(this);
    }
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'id', 'name', 'value', 'options', 'disabled', 'onChangeCallback' ]);
    }
    arrowKeyHandler(event) {
        const { id, value, options } = this.props;
        const LAST_ITEM_INDEX = options.length - 1;
        const { keyCode } = event;
        if (undefined === value || UNKNOWN === value) { return; }
        const selectedItemIndex = parseInt(event.target.getAttribute('data-index'));
        if ('number' !== typeof selectedItemIndex) { return; }
        const item = ReactDOM.findDOMNode(this);
        if (ARROW_LEFT === keyCode && 0 < selectedItemIndex) {
            item.querySelector(`label[for="${id}-${selectedItemIndex - 1}"]`).focus();
        } else if (ARROW_RIGHT === keyCode && LAST_ITEM_INDEX > selectedItemIndex) {
            item.querySelector(`label[for="${id}-${selectedItemIndex + 1}"]`).focus();
        }
    }
    static bindButtonCreator(id, name, value, onChangeCallback, disabled) {
        return function buttonCreator(buttonProperties, index) {
            return <Button num={index} {...buttonProperties} id={id} name={name} key={index} disabled={disabled}
                           checked={value === buttonProperties.value} onChangeCallback={onChangeCallback}/>;
        };
    }
    render() {
        const { id, name, value, unknownAccepted, options, disabled } = this.props;
        const isVisible = this.isVisible();
        return isVisible ? (
            <div className={style.fieldWrapper}>
                <div className={style.buttonsWrapper} onKeyDown={this.arrowKeyHandler}>
                    { options.map(RadioButtons.bindButtonCreator(id, name, value, this.onChangeHandler, disabled)) }
                </div>
                {
                    unknownAccepted
                        ? <DontKnowBtn disabled={disabled} onChangeCallback={this.onChangeHandler} value={UNKNOWN} checked={ UNKNOWN === value }/>
                        : null
                }
            </div>
        ) : null;
    }
}
RadioButtons.propTypes = {
    id: TYPES.string.isRequired,
    name: TYPES.string.isRequired,
    value: TYPES.any.isRequired,
    unknownAccepted: TYPES.bool,
    options: TYPES.array.isRequired
};
RadioButtons.defaultProps = { unknownAccepted: false, value: false };

export class YesNoButtons extends Component {
    shouldComponentUpdate(nextProps) {
        return compareObjectsInclusive(this.props, nextProps, [ 'id', 'name', 'value', 'options', 'disabled', 'onChangeCallback' ]);
    }
    render() {
        return <RadioButtons {...this.props} options={YesNoButtons.VARIANTS}/>;
    }
}
YesNoButtons.VARIANTS = [
    { title: _('Yes'), value: 'yes'  },
    { title: _('No'),  value: 'no' }
];
